import { DateTime } from "luxon";

import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";

export type IBFRemoteHazardAlarm = {
  date: DateTime;
  alarmType: number;
  fileNumber: number;
  lineNumber: number;
  errorCode: number;
};

export const IBF_REMOTE_HAZARD_ALARM = {
  value: 0x0080,
  name: "IBF_REMOTE_HAZARD_ALARM",
  size: 16,
  parse: (record): IBFRemoteHazardAlarm => {
    const date = record.nextDateTime();
    record.skip(1);
    const alarmType = record.nextUInt32LE();
    const fileNumber = record.nextUInt32LE();
    const lineNumber = record.nextUInt32LE();
    const errorCode = record.nextUInt32LE();
    return {
      date,
      alarmType,
      fileNumber,
      lineNumber,
      errorCode,
    };
  },
} satisfies IBFHistoryRecordDefinition<IBFRemoteHazardAlarm>;
